import Icon, { IconID } from '../common/Icon';

interface DeveloperCardProps {
  icon: IconID;
  onClick: () => void;
  title: string;
}

export const DeveloperCard = ({ icon, onClick, title }: DeveloperCardProps) => {
  return (
    <button
      className="flex flex-col items-center justify-center gap-4 w-48 h-72 rounded-2xl border border-gray-d-300 bg-white shadow-sm transition-colors hover:border-primary-d-600 hover:shadow-md"
      onClick={onClick}
      type="button"
    >
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-primary-d-50 text-primary-d-600">
        <div className="w-7 h-7">
          <Icon id={icon} />
        </div>
      </div>
      <span className="text-sm font-semibold text-gray-d-700">{title}</span>
    </button>
  );
};
